import store from '../store';
import { checkauth } from '../Helper';

const ServerHealth = () => import('../views/serverhealth/Index.vue');

// Gestione → Salute del server: solo il profilo Admin (role 0)
const soloAdmin = (to, from, next) => {
	checkauth().then(response => {
		if (!response) return next('/login');
		return store.getters['profile/getRole'] === 0 && !(store.getters['profile/getRollback'] || {}).email ? next() : next('/');
	});
};

// Sito ecommerce → Salute del server: staff dentro un profilo ("Loggati come"), come Velocità del sito
const soloStaff = (to, from, next) => {
	checkauth().then(response => {
		if (!response) return next('/login');
		return store.getters['profile/isAdminSession'] ? next() : next('/');
	});
};

export default [
	{ path: '/manage/server-health', name: 'manage-server-health', component: ServerHealth, meta: { area: 'manage' }, beforeEnter: soloAdmin },
	{ path: '/ecommerce/server-health', name: 'ecommerce-server-health', component: ServerHealth, meta: { area: 'ecommerce' }, beforeEnter: soloStaff },
];
